<template>
  <div class="query-container">
    <QueryView
      ref="queryView"
      :table-config="tableConfig"
      town-label="Municipio"
      :town-selection="true"
      :region-selection="false"
      :province-selection="true"
      use-expansion
    >
      <template #header>
        <MultiSelect
          v-model="selectedFields"
          :options="categories"
          option-label="label"
          option-value="field"
          filter
          placeholder="Categoría"
          class="w-full md:w-16rem query__category-select"
          @update:model-value="updateSelectedFields"
        >
          <template #option="slotProps">
            <div class="flex items-center custom-item-template">
              <span class="material-icons">{{ slotProps.option.icon }}</span>
              <span class="label-multiselect">{{ slotProps.option.label }}</span>
            </div>
          </template>
        </MultiSelect>
      </template>
      <template #expansion="{ data }">
        <div class="query__expansion-container">
          <QueryExpansionField
            field-name="Descripción"
            :field-value="data.description"
          />
          <QueryExpansionField
            field-name="Acceso"
            :field-value="data.access"
          />
        </div>
      </template>
    </QueryView>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryExpansionField from '@/components/query-expansion-field/QueryExpansionField';
import QueryTableConfig from '../query-table.view-config.js';
import {PUBLIC_WORKS_SCHEMA, PUBLIC_WORKS_FILTERS} from './query-public-works-table.view-config';
import MultiSelect from 'primevue/multiselect';
import {searchPublicWork} from '@/api/public-work/public-work.api';
import {
  searchPublicWorkHtml,
  searchPublicWorkPdf,
  getPublicWorkPdf,
} from '@/api/public-work/public-work.api.pdf.js';

const queryView = ref();
const {copy} = useClipboard();

function updateFilters() {
  queryView.value.updateAdvancedFilters(selectedFilters.value);
}

async function printPublicWork(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(data.id, 'Obra pública - ' + data.name, getPublicWorkPdf);
  }
}

async function htmlPublicWorkQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Obra pública', searchPublicWorkHtml, 'html');
  }
}

async function printPublicWorkQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Obra pública', searchPublicWorkPdf);
  }
}

async function goPublicWork({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 13;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}

function publicWorkToText({name, description, access, town, province, category}) {
  const res = `
    Nombre: ${name}
    Descripción: ${description}
    Acceso: ${access}
    Municipio: ${town}
    Provincia: ${province}
    Categoría: ${category}
    `;
  return res;
}

const tableConfig = new QueryTableConfig({
  title: '',
  api: searchPublicWork,
  recordToText: publicWorkToText,
  copyClipboard: copy,
  htmlQuery: htmlPublicWorkQuery,
  printQuery: printPublicWorkQuery,
  printRecord: printPublicWork,
  centerMap: goPublicWork,
  schema: PUBLIC_WORKS_SCHEMA,
  filterFields: [],
});

const selectedFields = ref([]);
const selectedFilters = computed(() => {
  return categories.value.map((category) => ({
    field: category.field,
    icon: category.icon,
    value: selectedFields.value.includes(category.field),
  }));
});

const categories = computed(() => {
  return PUBLIC_WORKS_FILTERS.map((item) => ({
    ...item,
  }));
});

function updateSelectedFields(newFields) {
  selectedFields.value = newFields;
  updateFilters();
}

</script>

<style lang="scss" scoped>
.query-container {
  & :deep(.p-chip) {
    display: none;
  }
}
.label-multiselect {
  padding-top: 3px;
  padding-left: 4px;
}
</style>
